export default {"src":"/_next/static/media/rightIcon.c61091a2.svg","height":166,"width":183,"blurWidth":0,"blurHeight":0};